import { buildApi } from '../http-client/http-client';
import withAuth from '../auth-service/with-auth';

export const getProductsByOppositionAndPlatform = withAuth(async (token, oppositionId, platform) => {
  const parsedPlatform = platform === 'ios' ? 'app_store' : 'default';
  return buildApi(token)
    .get(
      `${process.env.ECOMMERCE_BASE_URL}/ecommerce/api/oppositions/${oppositionId}/products?channel=${parsedPlatform}`,
    )
    .then(data => data._embedded.items)
    .then(items =>
      items.map(i => ({
        ...i,
        attributes: i.attributes.map(a => (a.code === 'appleProductId' ? { ...a, code: 'iosProductId' } : a)),
        variants: [
          {
            ...i.variants[0],
            channelPricings: Object.keys(i.variants[0].channelPricings).map(k =>
              i.variants[0].channelPricings[k].channelCode === 'app_store'
                ? { ...i.variants[0].channelPricings[k], channelCode: 'ios' }
                : i.variants[0].channelPricings[k],
            ),
          },
        ],
      })),
    );
});

export const processNewPurchase = withAuth(
  //TODO send user to backend when the backend accepts it
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async (token, platform, productId, storeProductId, receiptId, _transactionUser) => {
    const body =
      platform === 'ios'
        ? {
            productId: productId,
            appleProductId: storeProductId,
            recipeId: receiptId,
            app: 'oposV2',
          }
        : {
            productId: productId,
            androidProductId: storeProductId,
            receiptId,
            app: 'oposV2',
          };
    return buildApi(token).postFormData(
      `${process.env.ECOMMERCE_BASE_URL}/ecommerce/api/purchase/${platform === 'ios' ? 'apple' : 'android'}`,
      body,
    );
  },
);

export default {
  getProductsByOppositionAndPlatform,
  processNewPurchase,
};
